import React from 'react';
import * as AlertDialog from '@givebutter/primitives/alert-dialog';
import { Button } from '@givebutter/primitives/button';

const SendWarning = ({
    children,
    onProceed,
}: {
    children: React.ReactNode;
    onProceed?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}) => {
    return (
        <AlertDialog.Root>
            {children}
            <AlertDialog.Portal>
                <>
                    <AlertDialog.Overlay />
                    <AlertDialog.Content className="flex max-w-md flex-col gap-4 p-4">
                        <div className="text-xl">Send Immediately</div>
                        <p className="block text-base leading-normal">
                            You have not selected a scheduled date and time to send this message. It
                            will be sent immediately.
                            <br />
                            <strong>Do you wish to continue?</strong>
                        </p>
                        <div className="flex justify-between gap-4">
                            <AlertDialog.Close>Go Back</AlertDialog.Close>
                            <Button variant="solid" onClick={onProceed}>
                                Proceed
                            </Button>
                        </div>
                    </AlertDialog.Content>
                </>
            </AlertDialog.Portal>
        </AlertDialog.Root>
    );
};

const Root = SendWarning;
const Trigger = AlertDialog.Trigger;
const SendWarningTrigger = Trigger;

export {
    Root,
    Trigger,
    //
    SendWarning,
    SendWarningTrigger,
};
